<template>
    <div class="mr-4 ml-4">
        <f-title :title="title" />
        <drop class="w-100 cut" @drop="onDrop" mode="cut" :accepts-data="onAcceptData">
            <div v-if="recipients.length === 0" class="recipients-missing">

            </div>
            <div>
                <v-carousel
                    v-model         ="current"
                    :continuous     ="false"
                    :cycle          ="false"
                    :show-arrows    ="false"
                    :hide-delimiters="true"
                    height          ="100%"
                    class           ="pa-0 ma-0"
                    light
                >
                    <v-carousel-item v-for="(recipient,index) in recipients" :key="index">
                        <c-recipient-card
                            style        = "width: calc(100% - 1px)"
                            :company     = "recipient.recipient"
                            :enable-edit = "false"
                        >
                            <template v-slot:toolbar>
                                <div style="margin-top: -4px;">
                                    <c-toolbar-button
                                        icon    = "mdi-close"
                                        size    = "22"
                                        color   = "red"
                                        tooltip = "Entfernen"
                                        @click  = "onRemove(recipient)"
                                    />
                                </div>
                            </template>
                        </c-recipient-card>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </drop>
        <div class="navigation">
            <div class="v-flex" v-if="recipients.length > 1">
                <a v-for="(recipient, i) in recipients" :key="i" @click="current=i">
                    <div class="delimiter primary" :class="current===i?'selected':''"></div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import { Drop }              from "vue-easy-dnd"
import CRecipientCard from "@/modules/msd/company/recipient/components/CRecipientCard";
import FTitle from "@/modules/core/components/utils/FTitle";
import Site from "@/modules/msd/unit/service/Site";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "CSiteRecipientsSeparated",
    components: {
        CToolbarButton,
        FTitle,
        CRecipientCard,
        Drop
    },

    props: {
        title: {

        },

        recipients: {

        },

        usage: {

        },

        acceptProperty: {

        }
    },

    data: () => ({
        current : 0,
        USAGE: Site.RECIPIENT.USAGE,
        TYPE : Site.RECIPIENT.TYPE,
    }),

    methods: {
        onDrop (event) {
            let type = null;
            switch (this.acceptProperty) {
                case "invoice":
                    type = this.TYPE.INVOICE;
                    break;
                case "benefit":
                    type = this.TYPE.BENEFIT;
                    break;
            }

            this.$emit("assign", {
                recipient: event.data,
                type     : type,
                usage    : this.usage
            })
        },

        onRemove (event) {
            this.$emit("remove", event);
        },

        onAcceptData (recipient) {
            if (this.usage === this.USAGE.INCIDENT &&  recipient[this.acceptProperty] && recipient.usedOnIncidents) {
                return true;
            }

            if (this.usage === this.USAGE.REPAIR &&  recipient[this.acceptProperty] && recipient.usedOnRepair) {
                return true;
            }

            if (this.usage === this.USAGE.COSTS &&  recipient[this.acceptProperty] && recipient.usedOnCosts) {
                return true;
            }

            return false;
        }
    }
}
</script>

<style scoped>

.selected {
    opacity: 1!important;
}

.navigation {
    justify-content: center;
    bottom: 7px;
    right: 6%;
    display: flex;
    height: 16px;
}

.delimiter {
    width: 25px;
    height: 8px;
    margin-right: 10px;
    margin-top: 8px;
    opacity: 0.3
}

.recipients-missing {
    width: 100%;
    height: 190px;
    border-color: gray;
    border-width: 1px;
    border-style: dashed;
    border-radius: 4px;
}
</style>